import {
  getDatabase,
  ref,
  set,
} from 'firebase/database';

import { app } from './initializeApp';
import { getUid } from './getUid';

export const waterSet = date_int => async milliliters =>
{
  const uid = await getUid();

  return set
  (
    ref(getDatabase(app), `fatsecret/${ uid }/water/${ date_int }`),
    milliliters,
  );
};